// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S1Pn","title":"styles_title__3P_8K"};